import React from 'react'
import { Button, Modal, DialogContent, Spinner } from '@boulevard/blvd-ui'
import { observer } from 'mobx-react-lite'
import { apiClientStore } from '../stores'

export const ApiClientItem: React.FC = observer(() => {

  return (
    <React.Fragment>
      {apiClientStore.loader &&
      <Spinner className="spinner" size="large" positioning="overlay" animation="bounce" />}
      {apiClientStore.alerting &&
      <Modal
          size="small"
          open={apiClientStore.alerting}
      >
        <DialogContent
            headline=''
            footer={
              (
                <Button onClick={() => apiClientStore.clearAlert()} theme="primary">
                      Ok
                </Button>
              )
            }
        >
          <p style={{ marginTop: 0, marginBottom: 0 }}>
            {apiClientStore.alert.message}
          </p>
        </DialogContent>
      </Modal>}
    </React.Fragment>
  )
})
